<template>
    <modal-wrapper modalClass="modal--small" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h3>Openingstijd verwijderen</h3>
        </div>
        <div class="modal__content">
            Weet je zeker dat je deze openingstijd wilt verwijderen?
            <div class="row" style="margin: 2.4rem 0;">
                <div class="col-6">
                    <strong>{{getDay(time.day)}}</strong>
                </div>
                <div class="col-3">
                    <strong>{{time.open}}</strong>
                </div>
                <div class="col-3">
                    <strong>{{time.close}}</strong>
                </div>
            </div>
        </div>
        <div class="modal__footer">
            <button class="button--cta" type="submit" @click="confirm">Verwijderen</button>
            <button class="button--alt" type="button" @click="$modal.hide(name)">Annuleer</button>
        </div>

        <div class="loading" v-if="loading">
            <div class="spinner" style="top: 40%;"></div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import {getDayLong} from '@/utils';

    @Component
    export default class RemoveTimeModal extends Vue {
        name = 'remove-time-modal';

        time = {};
        loading = false;

        confirm() {
            this.loading = true;
            this.$emit('confirm', this.time);
        }

        beforeOpen(event) {
            this.loading = false;
            this.time = event.params.time;
        }

        getDay(day) {
            return getDayLong(day);
        }
    }

    Vue.component(RemoveTimeModal.name, RemoveTimeModal);
</script>



// WEBPACK FOOTER //
// src/pages/market/modals/RemoveTimeModal.vue